import  FilterPartners from './FilterPartners';
export default FilterPartners
